export const BRANDING = {
  logo: <img src="/logo.png" alt="MUI logo" />,
  title: "Back Office",
};
